/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Attachment } from './attachment';

export interface CommentDto {
  id?: string;
  parentId?: string;
  referenceId?: string;
  referenceName?: string;
  referenceType?: CommentDto.ReferenceTypeEnum;
  text?: string;
  createdTime?: string;
  attachment?: Attachment;
  createdBy?: string;
  replies?: Array<any>;
}
export namespace CommentDto {
  export const ReferenceTypeEnum = {
    WorkOrder: 'WORK_ORDER',
    WorkLine: 'WORK_LINE',
    Material: 'MATERIAL',
    Equipment: 'EQUIPMENT',
    Object: 'OBJECT',
    Document: 'DOCUMENT',
    MipsConstruction: 'MIPS_CONSTRUCTION',
    MipsEngineering: 'MIPS_ENGINEERING',
    MipsMaterial: 'MIPS_MATERIAL',
  } as const;
  export type ReferenceTypeEnum = (typeof ReferenceTypeEnum)[keyof typeof ReferenceTypeEnum];
}
